'use client';
import React from 'react';
import SearchAside from '@/app/_components/aside/SearchAside';
import ArchiveContent from '@/app/_components/archive/ArchiveContent';
import { useAllProducts } from '@/app/_hooks/useProduct';
import { useRouter } from 'next/navigation';
import { useState, useEffect } from 'react';
import SortFilter from '@/app/_components/widgets/SortFilter';
import ContactUsWidget from '@/app/_components/widgets/ContactUsWidget';
import AjaxPagination from '@/app/_components/share/AjaxPagination';
import { useSearchParams } from 'next/navigation';
import ArchiveContentList from './ArchiveContentList';
import { useIsMobile } from '@/app/_hooks/useIsMobile';

export default function SearchContentWrap({
  allBrands,
  allProducts,
  allCategories,
}) {
  const [openMobileSide, setOpenMobileSide] = useState(false);
  const { products, filters, setFilters } = useAllProducts();
  const [pageNumber, setPageNumber] = useState(1);
  const [productList, setProductList] = useState(allProducts);
  const searchParams = useSearchParams();
  const [isPriceList, setIsPriceList] = useState(false);

  const changePagination = (page) => {
    setPageNumber(page);
    const params = new URLSearchParams(searchParams.toString());
    params.set('page', page);
    setFilters(params.toString());

    // Scroll to the archive contianer section
    const archiveContentSection = document.getElementById('archiveContent');
    if (archiveContentSection) {
      archiveContentSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  useEffect(() => {
    if (products?.data) {
      setProductList(products);
    }
  }, [filters, products]);

  useEffect(() => {
    setFilters(searchParams.toString());
    setPageNumber(1);
  }, [searchParams]);

  return (
    <div className="category-archive-content flex pt-5 md:pt-10">
      <SearchAside
        brands={allBrands?.data}
        categories={allCategories?.data}
        count={products?.length}
        openMobileSide={openMobileSide}
        onCloseModalHandler={() => setOpenMobileSide(false)}
      />

      <div className="category-page-content flex-1">
        <div className="lg:hidden">
          <ContactUsWidget />
        </div>
        <SortFilter
          sort={filters?.sort}
          setOpenMobileSide={() => setOpenMobileSide(true)}
          isPriceList={isPriceList}
          setIsPriceList={setIsPriceList}
        />
        <div className={`${isPriceList ? 'block' : 'hidden'}`}>
          <ArchiveContentList products={productList.data} />
        </div>

        <div className={`${!isPriceList ? 'block' : 'hidden'}`}>
          <ArchiveContent products={productList.data} />
        </div>

        <AjaxPagination
          itemsPerPage={20}
          totalItems={productList?.meta?.total}
          currentPage={parseInt(pageNumber)}
          changePagination={(page) => changePagination(page)}
        />
      </div>
    </div>
  );
}
